import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageTaxPolicyStore } from "./localStorageStore";
import { createSupabaseTaxPolicyStore } from "./supabaseStore";
import type { TaxPolicyStore } from "./types";

const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const taxPolicyStore: TaxPolicyStore = useLocal
  ? createLocalStorageTaxPolicyStore()
  : createSupabaseTaxPolicyStore();

export type {
  TaxPolicy,
  TaxPolicyRegion,
  TaxPolicyStatus,
  TaxPolicyStore,
} from "./types";
